<script>
    import Form from 'form-backend-validation';
    import trans from '../mixins/trans';

    const default_locale = window.default_locale;

    export default {

        mixins: [
            trans
        ],

        data() {

            return {
                success: false,
                error: false,
                errors: [],
                uuid: this.createUuid(),

                id: null,

                form: new Form({
                    title: '',
                    additional: '',
                    salutation: '',
                    firstname: '',
                    lastname: '',
                    house_number: '',
                    street: '',
                    city: '',
                    zipcode: '',
                    country: 'DE',
                    company: '',
                    vat_id: '',
                }, {
                    resetOnSuccess: false,
                }),
            }
        },

        props: ['model', 'addressIndex', 'updateProfile', 'token', 'countries'],

        mounted() {
            this.id = this.model.id;
            this.form.populate(this.model);
            if (this.addressIndex == 0 && typeof(this.id) === 'undefined') {
                axios.get('/profile/user')
                    .then(data => {
                        let d = data.data;
                        this.form.populate({
                            salutation: d.gender,
                            firstname: d.firstname,
                            lastname: d.lastname,
                            title: d.title
                        });
                    })
                    .catch(function(e){if(e.code!=='ECONNABORTED'){throw e;}});
            }
        },

        watch: {
            model(value) {
                this.id = value.id;
                if (! value.id) {
                    this.form.reset();
                } else {
                    this.form.populate(value);
                }
            }
        },

        computed: {

            action(){
                return `/profile/address${this.id ? `/${this.id}` : ''}`;
            },

            method(){
                return this.id ? 'put' : 'post';
            },

            countryLabel(){
              return this.countries[this.form.country];
            }

        },

        methods: {

            reset(event) {
                this.form.errors.clear(event.target.name);
                this.success = false;
            },

            onSubmit(){
                this.error = false;
                this.errors = [];
                this.form[this.method](this.action)
                    .then(response => {
                        this.id = response.id;
                        this.success = true;
                        if(response.primary && this.updateProfile){
                            this.confirmProfileUpdate(response);
                        }
                    })
                    .catch(error => {
                        this.error = true;
                        let errors = this.errors;
                        $.each(error.response.data.errors, function(index, value) {
                            errors.push({field:index,value:value+''});
                        });
                        $('html, body').animate({ scrollTop: ($('[data-id="'+this.uuid+'"]').offset().top-parseInt($("#pageHeader").height()))}, 'slow');
                    });
            },

            deleteAddress(){
                if (this.id) {
                    axios.delete(this.action).then(response => {
                        this.$emit('user-address-deleted', this.addressIndex);
                    });
                } else {
                    this.$emit('user-address-deleted', this.addressIndex);
                }
            },

            createUuid(){
                let dt = new Date().getTime();
                let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                    let r = (dt + Math.random()*16)%16 | 0;
                    dt = Math.floor(dt/16);
                    return (c=='x' ? r :(r&0x3|0x8)).toString(16);
                });
                return uuid;
            },

            confirmProfileUpdate(response){

                let diverse = this.__(default_locale === 'en' ? 'Mx.' : 'Diverse');
                let firstname = response.firstname;
                let lastname = response.lastname;
                let title = response.title;
                let salutations = {null:this.__('no specification'),'male':this.__('Mr.'),'female':this.__('Mrs.'), 'diverse':diverse};
                let token = this.token;

                swal({
                    title: this.__('Feedback'),
                    text: this.__('You have not entered the personal data of your profile yet.') + " " + this.__('Do you want ":salutation :title :firstname :lastname" from this billing address to be stored as personal data of your account?').replace(/:salutation/,salutations[response.salutation]).replace(/:firstname/,firstname).replace(/:lastname/,lastname).replace(/:title/,title),
                    icon: "success",
                    buttons: [this.__('No'), this.__('Yes')],
                })
                .then(function (result) {
                    if(result === true) {
                        axios.post('/profile/name/update', {
                            params: {
                                _token: token
                            }
                        }).then((response) => {
                            $('#gender').val(response.data.address.salutation);
                            $('#firstname').val(response.data.address.firstname);
                            $('#lastname').val(response.data.address.lastname);
                            $('#title').val(response.data.address.title);
                            $('.profile-name').text(response.data.name);
                        });
                    }
                });
            }

        }
    }
</script>